import { Accordion, Grid, Paper } from "@mui/material";
import { FAQS } from "../../../constants/FAQs";
import Contact from "./contact/Contact";
import FAQ from "./FAQ/FAQ";

import "./FAQs.css";

const FAQs = (): JSX.Element => {
	return (
		<div className="FAQs">
			<div className="header">Frequently Asked Questions (FAQ) </div>
			<div className="theme-border-radius FAQ-paper-form-container">
				<Grid container columnSpacing={2}>
					<Grid item xl={5} lg={5} md={5}>
						<Contact />
					</Grid>
					<Grid item xl={7} lg={7} md={7}>
						<div className="FAQ-accordions">
							{FAQS.map((eachFAQ, index) => {
								if (index !== 0) {
									return (
										<div className="theme-plan-inner-section-margin" key={index}>
											<FAQ eachFAQ={eachFAQ} key={index} defaultExpanded={false} />
										</div>
									);
								}
								return <FAQ eachFAQ={eachFAQ} key={index} defaultExpanded />;
							})}
						</div>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default FAQs;
